import { Env } from '@/shared/config/environment';
import { SocketIOClient } from '@/shared/lib/broadcast';

export const broadcastClientConfig = {
  broadcaster: 'socket.io',
  host: Env.server.broadcastHost || `${window.location.hostname}:6001`,
  encrypted: true,
  client: SocketIOClient,
};
